import { TextField } from '@material-ui/core';
import React, { FC, memo, useCallback, useMemo } from 'react';

// import styled from 'styled-components'

// const LabelStyled = styled.label`
//   min-width: 260px;
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
// `

// const InputStyled = styled.input`
//   width: 180px;
// `

type InputProps = {
  min?: number;
  max?: number;
  minLength?: number;
  maxLength?: number;
};

const noop = () => undefined;

interface Props {
  label: string;
  value: string;
  onChange?: (v: string) => void;
  onInput?: (v: string) => void;
  type?: 'text' | 'password' | 'email' | 'number';
  fullWidth?: boolean;
  margin?: 'none' | 'dense' | 'normal';
  autoFocus?: boolean;
  disabled?: boolean;
  required?: boolean;
  min?: number;
  max?: number;
  minLength?: number;
  maxLength?: number;
  helperText?: string;
  error?: boolean;
}

export const MuiInput: FC<Props> = memo(
  ({
    label,
    value,
    onChange = noop,
    onInput = noop,
    type = 'text',
    margin,
    fullWidth = true,
    autoFocus,
    disabled,
    required,
    min,
    max,
    minLength,
    maxLength,
    helperText,
    error
  }: Readonly<Props>) => {
    const onChangeNative = useCallback(
      (ev: React.ChangeEvent<HTMLInputElement>) => {
        onChange(ev.target.value ?? '');
      },
      [onChange]
    );

    const onInputNative = useCallback(
      (ev: React.ChangeEvent<HTMLInputElement>) => {
        onInput(ev.target.value ?? '');
      },
      [onInput]
    );

    const inputProps: InputProps = useMemo(
      () => ({
        min,
        max,
        minLength,
        maxLength
      }),
      [min, max, minLength, maxLength]
    );

    return (
      <TextField
        label={label}
        value={value}
        onChange={onChangeNative}
        onInput={onInputNative}
        autoFocus={autoFocus}
        disabled={disabled}
        required={required}
        margin={margin}
        fullWidth={fullWidth}
        type={type}
        variant='standard'
        inputProps={inputProps}
        helperText={helperText}
        error={error}
      />
    );
  }
);

MuiInput.displayName = 'MuiInput';
